import React, { useState } from "react";
import Header from "../HomeHeader/Header";
import "./Library.css";
import Tree from "../../HomeScreenDetail/Tree";
import LibraryGrid from "../../HomeScreenDetail/LibraryGrid";
import { Splitter, SplitterPanel } from "primereact/splitter";
export default function Library({ setUploadingFiles, uploadingFiles }) {
  const [selectednewid, setSelectedNewid] = useState("");
  const [selectednewname, setSelectedNewName] = useState("");
  const [selectedNodeKeyLevel, setselectedNodeKeyLevel] = useState("");
  function onclicheck(value) {
    if (value !== undefined) getSelectedRowdatas(value);
  }
  function getSelectedRowdatas(selectedRowsData) {
    setSelectedNewid(selectedRowsData.id);
    setSelectedNewName(selectedRowsData.name);
    setselectedNodeKeyLevel(selectedRowsData.nodekeylevel);
  }
  return (
    <div>
      <Header />
      <Splitter>
        <SplitterPanel
          size={30}
          minSize={25}
          className="flex align-items-center justify-content-center"
        >
          <Tree onclickcheck={onclicheck} />
        </SplitterPanel>
        <SplitterPanel
          size={70}
          minSize={35}
          className="flex align-items-center justify-content-center"
        >
          <LibraryGrid
            setUploadingFiles={setUploadingFiles}
            uploadingFiles={uploadingFiles}
            selectednewid={selectednewid}
            selectednewname={selectednewname}
            selectedNodeKeyLevel={selectedNodeKeyLevel}
          />
        </SplitterPanel>
      </Splitter>
    </div>
  );
}
